export default [
  {
    header: 'Contabilità',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Importa Registr.',
    icon: 'TrelloIcon',
    route: 'importa-zip-contabilita',
    resource: 'cashflow', // 'contabilita',
    action: 'read',
  },
  {
    title: 'Registr. Contabili',
    icon: 'TrelloIcon',
    route: 'registrazioni-contabili',
    resource: 'cashflow', //'contabilita',
    action: 'read',
  },
  {
    title: 'Reg. Cont. Ministero',
    icon: 'TrelloIcon',
    route: 'registrazioni-contabili-ministero',
    resource: 'cashflow', //'contabilita',
    action: 'read',
  },
  {
    title: 'Tab. Racc. Dest.',
    icon: 'TrelloIcon',
    route: 'tabella-raccordo-destinatari',
    resource: 'cashflow', // 'contabilita',
    action: 'read',
  },
  {
    title: 'CashFlow',
    icon: 'TrelloIcon',
    route: 'cashflow',
    resource: 'cashflow',
    action: 'read',
  },
  {
    title: 'Distinte Pagamenti',
    icon: 'TrelloIcon',
    route: 'distinte',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Ordini',
    icon: 'TrelloIcon',
    route: 'ordini',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Bolle',
    icon: 'TrelloIcon',
    route: 'bolle',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Import Prev. Spett.',
    icon: 'TrelloIcon',
    route: 'importa-prev-spettacoli',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Verifica Bil. Ministero',
    icon: 'TrelloIcon',
    route: 'verifica-bilancio',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Allegato C',
    icon: 'TrelloIcon',
    route: 'allegato-c',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Bilancio Progetti',
    icon: 'TrelloIcon',
    route: 'bilancio-progetti',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Contrib. Sponsor',
    icon: 'TrelloIcon',
    route: 'contributi-sponsorship',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Spese Comunic.',
    icon: 'TrelloIcon',
    route: 'spese-comunicazione',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Verifica Pagamenti',
    icon: 'TrelloIcon',
    route: 'verifica-pagamenti',
    resource: 'contabilita',
    action: 'read',
  },
  {
    title: 'Scadenziario',
    icon: 'TrelloIcon',
    route: 'scadenziario',
    resource: 'contabilita',
    action: 'read',
  },

]
